import Vue from 'vue'
import io from 'socket.io-client'

export default function ({ $config }) {
  Vue.prototype.$socket = io($config.apiURL)
}
